export const HomePage_Offer_title_1 = `Valentine Special Offer`

export const HomePage_Offer_description_1 = `
Celebrate love this Valentine’s with a special offer made for couples. Book one plane ticket and get 
the second absolutely free, because memorable journeys are better together. Surprise your partner with 
a romantic getaway, explore new destinations hand in hand, and create unforgettable moments without doubling 
the cost. Love flies higher when you travel together.
`;


export const HomePage_Offer_title_2 = `New Year Offer`

export const HomePage_Offer_description_2 = `
Welcome the New Year with an exciting travel deal made to kickstart your adventures. Enjoy a flat 40% discount 
on flight bookings and turn your travel plans into reality without stretching your budget. Whether it’s a family 
holiday or a solo escape, start the year flying to your dream destination for less and celebrate new beginnings in style.
`;


export const HomePage_Offer_title_3 = `Christmas Offer`

export const HomePage_Offer_description_3 = `
Make this Christmas extra special with a family-friendly travel offer designed for joyful holidays. Book your 
flight and receive a complimentary ticket for children under 8 years, making it easier to travel together. 
Celebrate the festive season with your loved ones, create magical memories, and enjoy a stress-free journey 
filled with warmth, cheer, and holiday happiness.
`;


export const HomePage_Holiday_title_1 = `Family Holiday Trip`

export const HomePage_Holiday_description_1 = `
Plan the perfect Family Holiday Trip and turn quality time into unforgettable memories. Travel together, 
explore new destinations, and enjoy moments that bring everyone closer. Whether it’s a relaxing getaway or 
an exciting adventure, a family holiday is the best way to reconnect, unwind, and create stories you’ll 
cherish for years to come.

`;

export const HomePage_Holiday_title_2 = `Weekend Group Trip`

export const HomePage_Holiday_description_2 = `
A Weekend Group Trip is the perfect way to take a quick break from routine and recharge with friends. Escape 
the city, explore a new destination, and enjoy shared adventures, laughter, and unforgettable moments. Short, 
fun, and refreshing - this getaway is all about bonding, relaxation, and making the most of your weekend together.

`;

export const HomePage_Holiday_title_3 = `Winter Holiday Trip`

export const HomePage_Holiday_description_3 = `
A Winter Holiday Trip is the perfect escape to enjoy cozy moments and breathtaking seasonal views. From snow-covered 
landscapes to peaceful retreats, winter travel offers a refreshing break from routine. Embrace the chill, explore new 
destinations, and create warm memories with loved ones while experiencing the magic and charm of the winter season.
`;




export const OurExpertise_Description = `
Step into the Air Runner experience, where each flight is crafted with a passion for aviation and attention to detail. 
Every journey is designed to go beyond standard travel, offering comfort, precision, and memorable moments. Explore how 
thoughtful planning and excellence come together to create experiences that rise above expectations and redefine the way 
you fly.
`;

export const TravelAssistance_Description = `
Travel Assistance with Air Runner is designed to make every journey effortless and enjoyable. Discover expert tips on packing 
smart, navigating airports and borders with ease, calming first-time travel nerves, and travelling comfortably with pets. 
Beyond flights, Air Runner supports you at every step, ensuring a smooth, informed, and stress-free travel experience from 
start to finish.
`;

export const DestinationDiscovery_Description = `
Destination Discovery with Air Runner opens the door to exploring new places and unforgettable experiences. From hidden 
gems to popular hotspots, we inspire travelers to step beyond the familiar and discover destinations full of culture, 
beauty, and adventure. Whether you seek relaxation or excitement, Air Runner helps you uncover new journeys and create 
memories in places you’ve never been before.
`;

export const EliteCard_Description = `
The Air Runner Elite Card is designed to reward frequent flyers with exclusive benefits and extra savings. Enjoy additional 
discounts on every booking and unlock greater perks as you fly more. The card features three levels - Level 1, Level 2, and 
Level 3 - each upgraded after completing 100 flights, offering increasing rewards, privileges, and a more premium travel 
experience every step of the way.
`;

export const Offer_Description = `
Discover exciting offers with Air Runner, featuring special festive discounts, exclusive occasional deals, and many more 
savings throughout the year. Whether you’re traveling during celebrations or planning a spontaneous getaway, our offers 
are designed to make every journey more affordable and rewarding. Stay updated and enjoy great value on flights, because 
there’s always something special waiting for you.
`;

export const Holiday_Description = `
Plan your perfect getaway with Air Runner Holiday Plans, crafted to suit every kind of traveler. From festive escapes 
and seasonal breaks to relaxing family vacations and quick weekend trips, our holiday plans combine great destinations 
with attractive deals. Travel stress-free, explore more, and create unforgettable memories with thoughtfully designed 
holiday experiences made just for you.
`;




export const Bali_Description = `
Bali is a perfect blend of serene beaches, lush rice terraces, vibrant culture, and spiritual charm. From thrilling 
adventures to peaceful retreats, Bali offers something for every traveler. With Air Runner, reaching this tropical 
paradise becomes effortless, comfortable, and affordable—so you can focus on creating unforgettable memories while 
we take care of your journey.
`;

export const Paris_Description = `
Paris is a destination where romance, art, fashion, and history come together effortlessly. From the Eiffel Tower 
and Louvre Museum to cozy cafés and scenic Seine cruises, every corner tells a story. Travel to Paris with Air Runner 
and enjoy seamless flights, exclusive offers, and a premium journey that makes your Parisian escape truly unforgettable.
`;

export const Rome_Description = `
Rome is a living museum where ancient history meets modern charm. Explore legendary landmarks like the Colosseum, 
Roman Forum, and Vatican City while enjoying authentic Italian cuisine and vibrant street life. With Air Runner, your 
journey to Rome becomes effortless, letting you focus on discovering the culture, history, and soul of the Eternal City.
`;

export const Bangkok_Description = `
Bangkok is a vibrant blend of tradition and modern life, where golden temples meet buzzing street markets and world-class 
nightlife. From authentic Thai cuisine to rich cultural landmarks, the city offers unforgettable experiences. Fly with Air 
Runner and explore Bangkok with comfort, convenience, and exclusive travel benefits.
`;

export const Dubai_Description = `
Dubai is a city of luxury, innovation, and unforgettable skylines. From iconic landmarks like the Burj Khalifa to desert 
safaris and premium shopping, every moment feels extraordinary. Travel smart with Air Runner and enjoy seamless journeys 
to one of the world’s most dynamic destinations.
`;

export const Kyoto_Description = `
Kyoto invites travelers into Japan’s cultural heart, filled with ancient temples, serene gardens, and timeless traditions. 
Experience cherry blossoms, historic streets, and authentic cuisine. Let Air Runner take you to Kyoto, where every journey 
blends elegance, comfort, and discovery.
`;

export const London_Description = `
London is a global city rich in history, culture, and modern charm. From royal landmarks and museums to vibrant streets and 
theatres, it offers something for every traveler. Discover London with Air Runner, ensuring a smooth, stylish, and memorable 
travel experience.
`;


export const AboutUs_Description = `
Air Runner is a dynamic airline company delivering safe, efficient, and reliable air travel. Our modern aircraft fleet is 
maintained to global standards and operated by highly trained flight crews. Guided by an experienced management team, Air 
Runner also offers secure cargo services, ensuring timely transportation of goods alongside exceptional passenger 
experiences worldwide.
`;

export const Blogs_Description = `
Enjoy our blogs at Air Runner, where we share stories from the skies, travel tips, destination highlights, and insights 
into our services. From behind-the-scenes moments to passenger experiences, our blogs are designed to inspire your journeys, 
keep you informed, and help you make every flight with Air Runner smooth, comfortable, and memorable.
`;


export const Support_Description = `
Air Runner’s customer support is designed to make your travel seamless and stress-free. Our dedicated team assists with 
bookings, flight changes, baggage concerns, and special requests. Available across multiple channels, we provide timely, 
reliable help before, during, and after your journey—ensuring comfort, clarity, and confidence at every step of your travel 
experience.
`;

export const TermsAndCondition_Description = `
Air Runner’s Terms & Conditions outline user agreement, booking and payment rules, cancellation and refund policies, schedule 
change handling, and passenger responsibilities. By using Air Runner’s services, passengers agree to comply with fare conditions, 
travel documentation requirements, safety regulations, and conduct standards, while acknowledging that flight schedules and 
services may change due to operational or regulatory reasons.
`;


export const Policy_Description = `
Air Runner’s policies outline transparent booking and fares, flexible cancellation and refund rules, clear baggage allowances, 
structured check-in and boarding procedures, dedicated special assistance services, and strong website privacy practices. 
Together, these policies ensure passenger safety, data security, operational efficiency, and a smooth, reliable travel experience 
from booking to arrival.
`;
